import React from "react";
import { TextField } from "@mui/material";
import { QuestionCard } from "../shared/QuestionCard";

type Props = {
  value: string;
  onChange: (name: string) => void;
};

export function OwnerNameQuestion({ value, onChange }: Props) {
  return (
    <QuestionCard
      title="What's your name?"
      subtitle="So we can personalise your dog's plan"
      field="ownerName"
    >
      <TextField
        placeholder="e.g. John Smith"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoComplete="name"
        inputProps={{ autoCapitalize: "words" }}
        fullWidth
        variant="outlined"
        sx={{
          maxWidth: 400,
          "& .MuiOutlinedInput-root": {
            backgroundColor: "#FFFFFF",
            borderRadius: "10px",
            padding: 0,
            "& fieldset": { border: "2px solid #7B3306" },
            "&:hover fieldset": { border: "2px solid #7B3306" },
            "&.Mui-focused fieldset": {
              border: "2px solid #4A90E2",
              boxShadow: "0 0 8px rgba(74,144,226,0.35)",
            },
          },
          "& .MuiInputBase-input": {
            backgroundColor: "#FFFFFF",
            padding: { xs: "16px 14px", sm: "18px 14px" },
            fontWeight: 500,
            fontSize: { xs: "16px", sm: "15px" },
            lineHeight: 1.2,
            color: "#4A3026",
            textAlign: "center",
          },
          "& .MuiInputBase-input::placeholder": {
            color: "#A06B4D",
            opacity: 0.7,
          },
        }}
      />
    </QuestionCard>
  );
}
